import React, { useCallback } from 'react'
import RadioButton from 'src/components/Actions/radioButton';
import CheckBox from 'src/components/Form/checkbox';

export default function AdAccount({updateSelectedItems, list = [], level, selectedItems = [], isRadio = false}) {
  const selectedList = selectedItems?.find((item) => item.level == level)?.keywords || []
  const SelectBox = isRadio ? RadioButton : CheckBox
  
  return (
    <React.Fragment>
      {/* <h2 className='f-12 f-w-500 mb-2 f-101828'>Ad Accounts</h2> */}
      {!isRadio && list?.length > 1 ? (
        <div className='mt-3' style={{paddingLeft: '2px'}}>
          <CheckBox
            id="select_all_adaccount"
            label="Select All"
            classes={`f-12 f-w-500 f-101828 ${selectedList.length > 0 && selectedList.length !== list.length ? 'indet_check' : ''}`}
            checked={selectedList.length === list.length || selectedList.length > 0}
            action={(event) => updateSelectedItems(event, level, 'selectAll')}
          />
        </div>
      ) : null}
      
      <ul className='global-filter-tabs-list-items'>
        {list?.map((adAccount, index) => {
          return (
            <li key={adAccount?.value} className='d-flex align-items-center'>
              <div className='d-flex align-items-center gap-10'>
                <SelectBox
                  id={adAccount.value}
                  radioname={isRadio ? 'select-profile-id' : adAccount.value}
                  classes=""
                  value={adAccount.value}
                  checked={selectedList?.indexOf(adAccount.value) > -1}
                  action={(event) => updateSelectedItems(event, level, adAccount, isRadio)}
                />
                <div className='d-flex flex-column'>
                  <h2 className='f-12 f-w-500 d-flex align-items-center gap-4 f-101828'>
                    {adAccount.label}
                  </h2>
                  <span className='f-12 f-w-500 f-10182880 l-20'>{adAccount.value}</span>
                </div>
              </div>
            </li>
          )
        })}
        {list?.length == 0 ? <li className="text-dark f-10 f-w-500 hei-70 d-flex align-items-center justify-content-center no-wrap">No Ad Account found</li> : null}
      </ul>
    </React.Fragment>
  )
}